import React, { useState } from "react";
import MaterialIcon from "../../../../components/BuilderComponents/MaterialIcon";
import ButtonActionIcon from "../../../../components/BuilderComponents/ButtonActionIcon";
import BuilderRightSideBar from "../../../../Layouts/BuilderRightSideBar";
import SingleSelectBox from "../../../../components/FormComponents/SingleSelectBox";
import Textarea from "../../../../components/FormComponents/Textarea";
import Button from "../../../../components/FormComponents/Button";

const EditGatewayChangeLogic = ({ logic, selectionObj, changeLogic, setIsOpen }) => {
  const IDKey = "gateway_id";

  const handleGatewaySelection = (selectedGateway) => {
    changeLogic(IDKey, selectedGateway.id);
  };

  const handleConditionChange = (e) => {
    changeLogic("condition", e.target.value);
  };

  if (!logic) return null;

  return (
    <div className="edit_state_change_logic_container p_2">
      <div className="builder_form">
        <SingleSelectBox
          label="Select Gateway"
          selectedData={logic[IDKey]}
          options={selectionObj || []}
          onChange={handleGatewaySelection}
          placeholder="Select Gateway"
        />
      </div>

      <div className="builder_form" style={{ marginTop: "16px" }}>
        <Textarea
          label="Condition"
          value={logic.condition}
          onChange={handleConditionChange}
          placeholder="Enter condition logic"
        />
      </div>

      <div className="edit_logic_actions" style={{ marginTop: "24px" }}>
        <Button variant="primary" onClick={() => setIsOpen(false)}>
          Save
        </Button>
      </div>
    </div>
  );
};

const GatewayChangeLogic = ({ logic, setLogic, selectionObj }) => {
  const [isGatewayChangeLogicOpen, setIsGatewayChangeLogicOpen] = useState(true);
  const [isEditbarOpen, setIsEditbarOpen] = useState(false);
  const IDKey = "gateway_id";

  const addGatewayChangeLogic = (e) => {
    e.stopPropagation();
    const array = [...logic, { [IDKey]: "", condition: "true" }];
    setLogic(array);
    setIsEditbarOpen(logic.length);
  };

  const changeLogic = (key, value, index = isEditbarOpen) => {
    const array = [...logic];
    array[index][key] = value;
    setLogic(array);
  };

  const deleteGatewayChangeLogic = (index) => {
    const array = [...logic];
    const newArray = array.filter((_, i) => i !== index);
    setLogic(newArray);
  };

  const toggleGatewayChangeLogic = () => {
    setIsGatewayChangeLogicOpen((prevState) => !prevState);
  };

  const heading = "Gateway Change Logic";

  const resetsm = () => {
    if (logic[isEditbarOpen][IDKey] === "") {
      setLogic(logic.filter((_, index) => index !== isEditbarOpen));
    }
    setIsEditbarOpen(false);
  };

  function getNameFromSelectedObj(selectedObj, logicItem, idKey = "gateway_id") {
    const match = selectedObj.find((item) => item.id === logicItem[idKey]);
    return match?.name;
  }

  return (
    <div className={logic.length === 0 ? "activity_select_top_block empty-state" : "activity_select_top_block"}>
      <div className="post_activity_top" onClick={toggleGatewayChangeLogic}>
        <div
          className="section_sub_heading"
          style={{ marginBottom: "0px", textTransform: "capitalize", display: "flex", gap: "8px" }}
        >
          {heading}
          {/* <InfoTooltip documentKey="gateway_change_logic" /> */}
        </div>
        <MaterialIcon name="add" className="builder_action_btn_new add" onClick={addGatewayChangeLogic} />
      </div>

      {isGatewayChangeLogicOpen && (
        <div className="state_changeLogic_container">
          {logic?.map(
            (logicItem, index) =>
              logicItem[IDKey] && (
                <div className="state_changeLogic_inputs" key={index}>
                  <div className="icons">
                    <ButtonActionIcon type="edit" onClick={() => setIsEditbarOpen(index)} />
                    <ButtonActionIcon type="delete" onClick={() => deleteGatewayChangeLogic(index)} />
                  </div>
                  <div>
                    <label className="builder_label font_weight_normal" style={{ color: "var(--builder-light-text)" }}>
                      Gateway :{" "}
                    </label>
                    {selectionObj && (
                      <label className="builder_label font_size_small">
                        {getNameFromSelectedObj(selectionObj, logicItem, IDKey)}
                      </label>
                    )}
                  </div>
                  <div>
                    <label className="builder_label font_weight_normal" style={{ color: "var(--builder-light-text)" }}>
                      Logic :{" "}
                    </label>
                    <label className="builder_label font_size_small" style={{ textTransform: "none" }}>
                      {logicItem.condition}
                    </label>
                  </div>
                </div>
              )
          )}
        </div>
      )}
      <BuilderRightSideBar
        isOpen={isEditbarOpen === 0 || isEditbarOpen}
        heading="Gateway Change Logic"
        onClose={() => resetsm()}
      >
        <EditGatewayChangeLogic
          logic={logic[isEditbarOpen]}
          selectionObj={selectionObj}
          changeLogic={changeLogic}
          setIsOpen={setIsEditbarOpen}
        />
      </BuilderRightSideBar>
    </div>
  );
};

export default GatewayChangeLogic;
